import * as THREE from "three";

// Create a curved plane geometry with authentic CRT TV curvature
// Uses edge-weighted curvature: curves more along edges, less at corners
export function createCurvedPlaneGeometry(
  width: number,
  height: number,
  curvature: number,
  segments: number = 64,
): THREE.PlaneGeometry {
  const geometry = new THREE.PlaneGeometry(width, height, segments, segments);
  const positions = geometry.attributes.position as THREE.BufferAttribute;

  if (positions && curvature > 0) {
    for (let i = 0; i < positions.count; i++) {
      const x = positions.getX(i);
      const y = positions.getY(i);

      // Normalize coordinates to -1 to 1 range
      const nx = x / (width / 2);
      const ny = y / (height / 2);

      // Edge-weighted curvature formula:
      // Calculate independent edge contributions
      const xEdge = nx * nx;
      const yEdge = ny * ny;

      // Combine edges but reduce corner contribution
      // The (xEdge * yEdge) term subtracts extra at corners where both are large
      const cornerReduction = 0.7; // How much to reduce corner curvature (0-1)
      const edgeFactor = xEdge + yEdge - xEdge * yEdge * cornerReduction;

      // Bulge formula: center bulges forward, edges recede
      // but corners don't recede as much as pure radial would
      const bulge = curvature * (1 - edgeFactor) * 0.5;

      positions.setZ(i, bulge);
    }

    positions.needsUpdate = true;
    geometry.computeVertexNormals();
  }

  return geometry;
}
